import React, { useState } from 'react';
import styles from './Contact.module.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        comment: '',
        captcha: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Validate captcha
        if (formData.captcha !== '2') {
            alert('Please solve the math problem correctly');
            return;
        }

        console.log('Form submitted:', formData);
        // Reset form
        setFormData({
            fullName: '',
            email: '',
            phone: '',
            comment: '',
            captcha: ''
        });
        alert('Message sent successfully!');
    };
    return (
        <div className={styles.contactPage}>
            {/* Hero Section */}
            <section className={styles.heroSection}>
                <div className={styles.container}>
                    <div className={styles.heroContent}>
                        <div className={styles.textSection}>
                            <h1 className={styles.mainTitle}>
                                <span className={styles.titleDark}>Contact</span>{' '}
                                <span className={styles.titleBlue}>Us</span>
                            </h1>
                            <p className={styles.subtitle}>
                                Engage with Us to Foster Collaboration, Drive Innovation, and Build the
                                Future Together. Reach out for World-Class Support, Expert Guidance.
                            </p>
                        </div>

                        {/* World Map Illustration */}
                        <div className={styles.mapSection}>
                            <svg viewBox="0 0 600 400" className={styles.worldMapSvg}>
                                {/* World Map Dots Pattern */}
                                <defs>
                                    <pattern id="dotPattern" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse">
                                        <circle cx="4" cy="4" r="1.5" fill="#d1d5db" opacity="0.6" />
                                    </pattern>
                                </defs>

                                {/* Continents outline with dots */}
                                <g fill="url(#dotPattern)">
                                    {/* North America */}
                                    <path d="M50 80 Q80 70 120 75 Q150 80 180 85 Q200 90 190 120 Q180 150 160 140 Q130 135 100 130 Q70 125 50 120 Z" />

                                    {/* South America */}
                                    <path d="M140 180 Q150 160 170 170 Q180 180 175 220 Q170 260 160 280 Q150 300 140 290 Q130 270 135 240 Q138 210 140 180 Z" />

                                    {/* Europe */}
                                    <path d="M220 60 Q240 55 260 60 Q280 65 275 85 Q270 105 255 100 Q240 95 225 90 Q215 80 220 60 Z" />

                                    {/* Africa */}
                                    <path d="M240 120 Q260 115 280 125 Q290 140 285 180 Q280 220 270 240 Q260 255 250 250 Q240 245 245 210 Q248 170 240 120 Z" />

                                    {/* Asia */}
                                    <path d="M300 70 Q340 65 380 75 Q420 85 450 95 Q470 105 465 135 Q460 165 440 160 Q400 155 360 150 Q320 145 300 140 Q285 120 300 70 Z" />

                                    {/* Australia */}
                                    <path d="M420 240 Q450 235 470 245 Q485 255 480 270 Q475 285 460 280 Q445 275 430 270 Q415 260 420 240 Z" />
                                </g>

                                {/* India Location Marker */}
                                <g transform="translate(340, 160)">
                                    <circle cx="0" cy="0" r="8" fill="#3b82f6" opacity="0.3" />
                                    <circle cx="0" cy="0" r="6" fill="#3b82f6" />
                                    <circle cx="0" cy="0" r="3" fill="#ffffff" />
                                    {/* Pulse animation circles */}
                                    <circle cx="0" cy="0" r="12" fill="none" stroke="#3b82f6" strokeWidth="2" opacity="0.4">
                                        <animate attributeName="r" values="12;20;12" dur="2s" repeatCount="indefinite" />
                                        <animate attributeName="opacity" values="0.4;0;0.4" dur="2s" repeatCount="indefinite" />
                                    </circle>
                                </g>

                                {/* Additional decorative dots */}
                                <g fill="#e5e7eb" opacity="0.4">
                                    <circle cx="100" cy="50" r="2" />
                                    <circle cx="200" cy="40" r="1.5" />
                                    <circle cx="350" cy="45" r="2" />
                                    <circle cx="450" cy="60" r="1.5" />
                                    <circle cx="500" cy="80" r="2" />
                                    <circle cx="80" cy="320" r="1.5" />
                                    <circle cx="180" cy="340" r="2" />
                                    <circle cx="380" cy="320" r="1.5" />
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Information Section */}
            <section className={styles.contactInfoSection}>
                <div className={styles.container}>
                    <div className={styles.contactCard}>
                        <div className={styles.contactGrid}>
                            {/* Phone */}
                            

                            {/* Email */}
                            <div className={styles.contactItem}>
                                <div className={styles.contactIcon}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className={styles.contactContent}>
                                    <h3 className={styles.contactLabel}>Email</h3>
                                    <p className={styles.contactValue}>piscesia.info@gmail.com</p>
                                </div>
                            </div>

                            {/* Location */}
                            <div className={styles.contactItem}>
                                <div className={styles.contactIcon}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className={styles.contactContent}>
                                    <h3 className={styles.contactLabel}>Location</h3>
                                    <p className={styles.contactValue}>
                                        <strong>Corporate Office:</strong><br />
                                        906, Wave Silver Tower, Sector-18, Noida – 201301, Uttar Pradesh, India<br /><br />
                                        <strong>Registered Office:</strong><br />
                                        Chamber No. 1, 9C/48, Vrindavan Yojna, R.B. Road,<br />
                                        Lucknow – 226016, Uttar Pradesh, India
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Form Section */}
            <section className={styles.contactFormSection}>
                <div className={styles.container}>
                    <div className={styles.formContainer}>
                        <h2 className={styles.formTitle}>Send us a message</h2>

                        <form onSubmit={handleSubmit} className={styles.contactForm}>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>Full name</label>
                                    <input
                                        type="text"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        className={styles.formInput}
                                        required
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label className={styles.formLabel}>Email address</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        className={styles.formInput}
                                        required
                                    />
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    className={styles.formInput}
                                    required
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}>Comment</label>
                                <textarea
                                    name="comment"
                                    value={formData.comment}
                                    onChange={handleInputChange}
                                    className={styles.formTextarea}
                                    rows="6"
                                    required
                                ></textarea>
                            </div>

                            {/* <div className={styles.captchaGroup}>
                                <div className={styles.captchaLabel}>1 + 1 =</div>
                                <input
                                    type="text"
                                    name="captcha"
                                    value={formData.captcha}
                                    onChange={handleInputChange}
                                    className={styles.captchaInput}
                                    required
                                />
                            </div> */}

                            <div className={styles.submitButtonContainer}>
                                <button
                                    type="submit"
                                    className={styles.submitButton}
                                    aria-label="Submit contact form to send message to PISCESIA"
                                >
                                    SEND MESSAGE
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            {/* Career Section */}
            <section className={styles.careerSection}>
                <div className={styles.container}>
                    <div className={styles.careerCard}>
                        <div className={styles.careerContent}>
                            <div className={styles.careerText}>
                                <div className={styles.careerLabel}>APPLICATIONS</div>
                                <h2 className={styles.careerTitle}>
                                    All our job opportunities<br />
                                    are available here
                                </h2>
                            </div>
                            <div className={styles.careerButton}>
                                <a href="mailto:piscesia.info@gmail.com">
                                    <button
                                        className={styles.careerBtn}
                                        aria-label="Explore career opportunities at PISCESIA"
                                        type="button"
                                    >
                                        <span>CAREER @PISCESIA</span>
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            aria-hidden="true"
                                        >
                                            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Green Bottom Section */}
            <section className={styles.greenSection}>
                <div className={styles.container}>
                    <div className={styles.greenContent}>
                        {/* This can be used for additional content if needed */}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact; 